<template>
    <div class="Headers" :style="{'background':theme}">
        <div class="Headers_content FFF ft14">
            <div>
                <img :src="HeaderImg" alt="">
            </div>
            <div class="Headers_content_ul flex">
                <ul>
                    <li v-for="(item,index) in listPath" :key="index"  @click="setCenter(index)">
                        <!-- <router-link :to="item.path" :class="selectIndex == index ? 'selectedColor':''">{{item.title}}</router-link> -->
                        <router-link :to="item.path" :class="currentPath===item.path?'active-text':''">{{item.title}}</router-link>
                    </li>
                </ul>
            </div>
            <div>
                <span>您好！{{customerName}}</span> 
                <span style="margin-left:20px;margin-right:15px;">|</span>
                <span @click="loginoutevent" class="cursorP">退出</span>
            </div>
        </div>
    </div>
</template>
<script>
import LOGO from '@/assets/img/logo.png'
import  {LoginOut}  from '@/api/api'
import {Storage} from "@/utils/storage"
import { mapGetters } from 'vuex'
export default({
    name: 'Headers',
    data(){
        return {
            HeaderImg:LOGO,
            customerName:'',
            selectIndex:null,
            listPath:[
                {path:"/home",title:"首页"},
                {path:"/home/contentmain",title:"我的订单"},
                {path:"/home/main/favorites",title:"收藏夹"},
                {path:"/home/shopcar",title:"购物车"},
                {path:"/home/main/fundsituation",title:"服务中心"},
            ],
            currentPath: ''
        }
    },
    watch: {
        $route(val) {
            this.currentPath =val.path
        }
    },
     computed: {
        ...mapGetters({
            theme: 'theme'
        })
    },
    created(){
        this.currentPath = this.$route.path
       this.customerName = Storage.l.get('customerName');
    },
    methods:{
        // 切换激活样式
        setCenter(index) {
            this.selectIndex = index;
            this.currentPath = this.listPath[index].path
            console.log(this.currentPath)
        },
        loginoutevent(){
            LoginOut().then((res)=>{
                if(res.code === 200){
                    // 清除token，编码 ，经销商名称
                    Storage.l.remove('TokenKey');
                    Storage.l.remove('customerName');
                    Storage.l.remove('customerCode');
                    this.$router.push("/login");
                }
            }).catch(error=>{
                this.$message.error(error.message);
            });
        }
    }
})
</script>
<style lang="scss" scoped>
    .Headers{        
        width:100%;
        line-height: 56px;
        height: 56px;
        min-width: 1400px;
        position: fixed;
        top: 0;
        z-index: 99;
        .active-text{
            // font-size: 16px;
            font-size: 20px;
            font-weight: bold;
        }
        .Headers_content{
            margin: auto;
            max-width: 1300px;
            display: flex;
            justify-content: space-between;
            img{
              height: 50px;
                vertical-align: middle;
            }
            .Headers_content_ul li{
                display: inline-block; 
                // font-size: 14px;
                font-size: 18px;
                text-align: center;
                margin: 0px 20px;
                a{
                    display: block;
                    height: 100%;
                    width: 100%;
                    color: #FFFFFF;
                    text-decoration:none;
                }
            }
        }
        .selectedColor{
          font-weight: bold;
          color: red;
        }
    }
</style>
